export default __webpack_public_path__ + "static/media/cypress.fa262ecc.svg";